module.exports = __webpack_public_path__ + "79cd91d32fc207f45ab9aca14478e020.jpg";